import { PackingListDto } from '@pf/platform-wms/domain';
import { getCustomFieldValue } from '@pf/shared/util-platform';
import { CpwPackingCustomFields } from './cpw-package.model';

export function isParcelPackingList(packingList: PackingListDto): boolean {
    const persistedType = getCustomFieldValue<string>(
        packingList.customFields,
        CpwPackingCustomFields.PackageType
    );
    if (persistedType === 'box' || persistedType === 'pallet') {
        return persistedType === 'box';
    }
    return !!packingList.item?.id;
}
